module.exports = __webpack_public_path__ + "img/5.b03fc788.png";